<style>

.upload-pic{
  margin: auto;
  width: 300px;
  height: 300px;
  background-image: url('/i/alison-james.jpg');
  background-color: gray;
  background-repeat: no-repeat;
  background-origin: border-box;
  background-clip: border-box;
  background-size: cover;
}

.name{
  font-size: 24px;
  text-align: center;
  margin: 10px;
}

.bio{
  width: 300px;
  margin: 20px auto;
}

.photos{
  display: flex;
  justify-content: center;
  margin-bottom: 40px;
}

.a-photo{
  width: 100px;
  height: 100px;
  background-image: url('/i/alison-james-pic01.jpg');
  background-color: gray;
  background-repeat: no-repeat;
  background-origin: border-box;
  background-clip: border-box;
  background-size: cover;
  margin: 5px;
}

.upcoming{
  font-family: Sansation;
  font-size: 14px;
  font-style: italic;
  width: 300px;
  margin: 20px auto 10px auto;
}

.card{
  position: relative;
  color: white;
}

.event-name{
  font-size: 21px;
}

.starts-in {
  position: absolute;
  top: 5px;
  left: 5px;
  padding: 5px;
  background-color: rgba(0,0,0,0.8);
}
.info{
  position: absolute;
  bottom: 10px;
  left: 0;
  right: 0;
  padding: 5px;
  /* border: 1px red solid; */
  /* margin-top: -40px; */
  background-color: rgba(0,0,0,0.8);
}

img{
  object-fit: cover;
  width: 100%;
}

</style>

<Header
buttons="{ [ {icon: 'icon-calendar_add', text: 'Add Event', callback: 'addEvent', disabled: false, }, {icon: 'icon-pencil3', text: 'Edit Profile', callback: 'editProfile', disabled: false, }, ] }"
on:addEvent="{ () => push('/create-new-event') }"
on:editProfile="{ () => push('/edit-profile') }">Profile</Header>
<div class="has-header"></div>

<div class="card">
  <img src="/i/alison-james.jpg" alt="" class="img">
</div>
<!-- <div class="upload-pic"></div> -->

<div class="name">{name}</div>

<div class="bio">{bio}</div>

<div class="photos">
  <div class="a-photo"></div>
  <div class="a-photo"></div>
  <div class="a-photo"></div>
</div>

<div class="upcoming">Alison's Upcoming Events</div>

<div class="card">
  <img src="/i/alison-james-event01.jpg" alt="" class="img">
  <div class="starts-in"><StartsIn currentTime="{currentTime}" startsAt="{eventStartsAt}" endsAt="{eventEndsAt}"></StartsIn></div>
  
  <div class="info">
    <div class="event-name">{eventName}</div>
    <div><Stars stars="{eventStars}"></Stars></div>
    <div><EventTime startsAt="{eventStartsAt}" endsAt="{eventEndsAt}"></EventTime></div>
  </div>
</div>

<div class="has-action-bar"></div>
<ActionBar></ActionBar>


<script>

import {push, pop, replace, location} from 'svelte-spa-router';

import Header from "../components/Header.svelte";
import ActionBar from "../components/ActionBar.svelte";
import Stars from "../components/Stars.svelte";
import EventTime from "../components/EventTime.svelte";
import StartsIn from "../components/StartsIn.svelte";

let date = Math.round( Date.now() / 1000 );
let currentTime =  Math.round( Date.now() / 1000 );

let eventName = "Kundalini Yoga on the Beach";
let eventStars = 4.5;
let eventStartsAt = date + (3600 * 24);
let eventEndsAt = date + (3600 * 25);

let username = "@alison93";
let name = "Alison James";
let phone = "805-555-5555";
let email = "alij83@example.com";
let birthday = "02/21/1983";
let password = "Alison James";
let bio = "I absolutely love grass.  The green kind.  My favorite grass is the kind you can lay on.";

</script>